import React from 'react';
import Navbar from '../Header/Navbar/Navbar';
import emailjs from 'emailjs-com';
import './Contact.css';
import Footer from '../Footer/Footer';
import done from '../../images/icon/done.png';
const Contact = () => {

    function sendEmail(e) {
        e.preventDefault();
        emailjs.sendForm('service_z8l9jp2', 'template_yqj1yo8', e.target, 'user_fCffiAVcjnbQ0dq91yGtY')
            .then((result) => {
                document.getElementById('name').value = "";
                document.getElementById('email').value = "";
                document.getElementById('message').value = "";
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
    }

    return (
        <div>
            <Navbar></Navbar>
            <div className="container my-5 my-contact">
                <div className="header text-center">
                    <h2>CONTACT <span>ME</span></h2>
                    <p>Have a question or want to work together? I'd really love to hear from your feedback.</p>
                    <div className="wrapper">
                        <div className="divider div-transparent div-dot"></div>
                    </div>
                </div>
                <div className="row my-5">

                    <div style={{ backgroundColor: "rgb(23, 42, 69)" }} className='mx-auto contact-form my-3 p-3 px-4' >
                        <div className="">
                            <h2 className="text-center mb-4">GET IN TOUCH</h2>
                            <form action="" onSubmit={sendEmail}>
                                <div className="form-group">
                                    <input id="name" name="name" placeholder="Your Name" type="text" className="form-control" required />
                                </div>
                                <div className="form-group">
                                    <input id="email" name="email" placeholder="Your Email" type="email" className="form-control" required />
                                </div>
                                <div className="form-group">
                                    <textarea id="message" name="message" rows="4" placeholder="Your Message" type="text" className="form-control" required></textarea>
                                </div>
                                <div className=" text-center form-group" data-target="#exampleModal" data-toggle="modal">
                                    <button style={{ backgroundColor: "#e9af1d" }} type="submit" className="btn btn-block">Send</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                 {/* modal */}
                 <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div style={{ color: '#000'}} className="modal-body text-center">
                            <img src={done} style={{ fontSize: '5em' }} alt="" />
                            <div className="mt-3">
                            <h5> Thank you...! </h5>
                            <h5>Your Message Send Successfully</h5>  
                            </div>                 
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
            <Footer></Footer>
        </div>
    );
};

export default Contact;